import PropTypes from 'prop-types';
import React from 'react';
import { TitleSummary } from '../../style';

export const HeaderComponet = ({ field }) => {

  return (
    <>
      <React.Fragment key={field.idInput}>
        <TitleSummary >{field.label}</TitleSummary>
      </React.Fragment>
    </>
  );
};

HeaderComponet.propTypes = {
  field: PropTypes.object.isRequired,
};
